import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/users/$userId/compare')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle('users.compare.page_title', 'Compare User'),
      },
    ],
  }),
});
